"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import "../../api/api";
import DisablingButton from "../../components/disabling_button";
import InvoiceAbandonerReason from "./invoice_abandoner_reason";
import InvoiceAbandonerRadioGroup from "./invoice_abandoner_radio_group";
const InvoiceAbandonerForm = ({
  abandon,
  abandoning,
  duplicateInvoice,
  error,
  isPaymentsNetworkSubmission,
  onCancel,
  onChangeOption,
  onChangeReason,
  reason,
  selectedOption
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "row", children: [
    /* @__PURE__ */ jsx(
      InvoiceAbandonerReason,
      {
        error,
        isPaymentsNetworkSubmission: !!isPaymentsNetworkSubmission,
        onChange: onChangeReason,
        selectedOption,
        value: reason
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "small-12 column", children: [
      duplicateInvoice && /* @__PURE__ */ jsx(
        InvoiceAbandonerRadioGroup,
        {
          duplicateInvoice,
          onChangeOption,
          selectedOption
        }
      ),
      /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "button--confirmation",
          disabled: abandoning,
          disabledText: "Ignoring...",
          onClick: abandon,
          children: "Ignore Invoice"
        }
      ),
      /* @__PURE__ */ jsxs("span", { className: "button--cancel-wrapper", children: [
        /* @__PURE__ */ jsx("span", { children: "or" }),
        /* @__PURE__ */ jsx("button", { onClick: onCancel, className: "button--cancel", children: "cancel" })
      ] })
    ] })
  ] });
};
export default InvoiceAbandonerForm;
